'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable import/no-extraneous-dependencies */


var UAHeader = function (_React$Component) {
  _inherits(UAHeader, _React$Component);

  function UAHeader() {
    _classCallCheck(this, UAHeader);

    return _possibleConstructorReturn(this, (UAHeader.__proto__ || Object.getPrototypeOf(UAHeader)).apply(this, arguments));
  }

  _createClass(UAHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          menu = _props.menu,
          className = _props.className,
          handleMenuClick = _props.handleMenuClick;

      return _react2.default.createElement(
        'header',
        { id: 'UAHeader', className: (0, _classnames2.default)('pp-legal-header', className) },
        _react2.default.createElement(
          'div',
          { className: 'header-top' },
          menu && menu.text && _react2.default.createElement(
            'div',
            { className: 'header-buttons-left visable-md hidden-lg' },
            _react2.default.createElement(
              'a',
              {
                className: 'btn btn-small btn-secondary',
                href: '#top',
                id: 'menu-btn',
                onClick: function onClick() {
                  return handleMenuClick();
                }
              },
              menu.text
            )
          ),
          _react2.default.createElement(
            'a',
            { className: 'paypal-img-logo', href: '/webapps/mpp/home' },
            'PayPal'
          ),
          title && title.text && _react2.default.createElement(
            'h1',
            { className: 'hidden-md hidden-sm hidden-xs' },
            title.text
          )
        )
      );
    }
  }]);

  return UAHeader;
}(_react2.default.Component);

exports.default = UAHeader;


UAHeader.propTypes = {
  title: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  menu: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  className: _propTypes2.default.string,
  handleMenuClick: _propTypes2.default.func.isRequired
};

UAHeader.defaultProps = {
  title: {
    text: ''
  },
  menu: {
    text: ''
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/user-agreement/jsx/UAHeader.js
// module id = 1153
// module chunks = 4